import { Alert } from "@mui/material";
import HelpArticleLink from "@entrilia/shared/components/HelpArticleLink";
import { intercomArticleIds } from "../../../../utilities/intercomArticles";

interface Props {
  includeTime: boolean;
}

const WatermarkDateWarning = ({ includeTime }: Props) => {
  return (
    <Alert severity="warning">
      {includeTime ? (
        <>
          Some investors <strong>will not be able</strong> to open or download documents.
        </>
      ) : (
        <>
          Some investors <strong>may experience a delay</strong> when opening or downloading documents.
        </>
      )}

      <HelpArticleLink
        articleId={intercomArticleIds.INVESTOR_DOCUMENT_BLOCKED_BY_NETWORK}
        underline="hover"
        sx={{ ml: 1, whiteSpace: "nowrap" }}
      >
        Learn More
      </HelpArticleLink>
    </Alert>
  );
};

export default WatermarkDateWarning;
